/**
 * 所有账号相关的请求ajax函数
 */

import request from "@/utils/request";

// // 单点登录
// export function login(params) {
//    return request.post(`/x_organization_assemble_authentication/jaxrs/authentication`, params);
// }

// 获取指定文档的全部附件信息列表.（所有附件列表）
export function listFileInfoByDocumentId(params) {
   return request.get(`/x_cms_assemble_control/jaxrs/anonymous/fileinfo/list/document/${params.url.id}`, params.data);
}
// 根据信息发布文档ID查询文档所有的图片信息列表.（图片附件列表）
export function listAllPictures(params) {
   return request.get(`/x_cms_assemble_control/jaxrs/anonymous/document/pictures/${params.url.id}/all`, params.data);
}

// 匿名访问栏目信息（文章列表）
export function listNextWithFilter(params) {
   // page:页数  size:每页数目
   return request.put(`/x_cms_assemble_control/jaxrs/anonymous/document/filter/list/${params.url.page}/size/${params.url.size}`, params.data);
}

// 匿名访问栏目上一页信息（文章列表）
export function listPrev(params) {
   // id:最后一条信息ID，如果是第一页，则可以用(0)代替  count:每页数目
   return request.put(`/x_cms_assemble_control/jaxrs/anonymous/document/filter/list/${params.url.id}/prev/${params.url.count}`, params.data);
}
// 匿名访问栏目下一页信息（文章列表）
export function listNext(params) {
   // id:最后一条信息ID，如果是第一页，则可以用(0)代替  count:每页数目
   return request.put(`/x_cms_assemble_control/jaxrs/anonymous/document/filter/list/${params.url.id}/next/${params.url.count}`, params.data);
}

// 根据ID访问信息发布文档信息对象详细信息，包括附件列表，数据信息.（文章详情）
export function view(params) {
   // id:最后一条信息ID，如果是第一页，则可以用(0)代替  count:每页数目
   return request.get(`/x_cms_assemble_control/jaxrs/anonymous/document/${params.url.id}/view`, params.data);
}

// 根据ID访问信息发布文档信息对象详细信息，包括附件列表，数据信息.（文章详情）
export function listPublishableCategoryInfo(params) {
   // id:最后一条信息ID，如果是第一页，则可以用(0)代替  count:每页数目
   return request.get(`/x_cms_assemble_control/jaxrs/anonymous/categoryinfo/list/publish/app/${params.url.id}`, params.data);
}

export function listPublishableCategoryAll(params) {
   return request.get(`/x_cms_assemble_control/jaxrs/anonymous/categoryinfo/list/view/app/${params.url.id}/all`, params.data);
}

